import { PersoneService } from './../services/persone.service';
import { IPersona } from './../interfaces/IPersona';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig, MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { AlertUtil } from '../utils/alert-util';
import { DocumentiService } from '../services/documenti.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import * as Moment from 'moment'

@Component({
  selector: 'app-persona-modal',
  templateUrl: './persona-modal.component.html',
  styleUrls: ['./persona-modal.component.css']
})
export class PersonaModalComponent implements OnInit {

  @ViewChild('op') op: OverlayPanel

  persona: IPersona
  fromFiliera: boolean
  itemsAllegato: MenuItem[];

  cfPattern = "^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$"

  fileName: string  // name of file already uploaded
  uploadedFile: any //for upload file
  attachmentUrl: string = ""                  // url dell'allegato

  personaForm: FormGroup
  isUpdate: boolean = false

  it: any //object for italian calendar

  constructor(private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private translate: TranslateService,
    private alertUtil: AlertUtil,
    private formBuilder: FormBuilder,
    private personaService: PersoneService) {
    this.persona = this.config.data.persona
    this.fromFiliera = this.config.data.fromFiliera
    this.isUpdate = this.persona ? true : false

    // build italian options for calendar
    this.it = {
      firstDayOfWeek: 1,
      dayNames: ["domenica", "lunedì", "martedì", "mercoldì", "giovedì", "venerdì", "sabato"],
      dayNamesShort: ["do", "lu", "ma", "me", "gio", "ve", "sa"],
      dayNamesMin: ["D", "L", "m", "M", "G", "V", "S"],
      monthNames: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"],
      monthNamesShort: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
      today: 'Oggi',
      clear: 'Cancella'
    }

    //build form group
    this.serForm();
  }

  ngOnInit() {
  }

  private serForm() {
    this.personaForm = this.formBuilder.group({
      'nome': [this.isUpdate ? this.persona.Nome : '', Validators.required],
      'cognome': [this.isUpdate ? this.persona.Cognome : '', Validators.required],
      'codiceFiscale': [{ value: this.isUpdate ? this.persona.Codice_fiscale : '', disabled: this.isUpdate }, Validators.compose([Validators.required, Validators.max(99999999999), Validators.min(0)])],
      'dataAssunzione': [this.isUpdate ? this.formatDateForChart(this.persona.Data_assunzione) : '', Validators.required],
      'mansioneQualifica': [this.isUpdate ? this.persona.Mansione : '']
    });
  }

  // convenience getter for easy access to form fields
  get form() { return this.personaForm.controls; }

  /**
  * format date for html
  * @param date string from service
  */
  formatDateForChart(date: any): string {
    // format date value
    let valueMoment = Moment(date, "YYYY-MM-DDTHH:mm:ssZ", true)
    if (valueMoment.isValid()) {
      date = valueMoment.format("DD/MM/YYYY")
    }
    return date
  }

  onSubmit() {
    if (this.personaForm.valid) {
      //retrieve values from form
      let nome = this.personaForm.controls['nome'].value
      let cognome = this.personaForm.controls['cognome'].value
      let codiceFiscale = this.personaForm.controls['codiceFiscale'].value
      let dataAssunzione = this.personaForm.controls['dataAssunzione'].value
      let mansioneQualifica = this.personaForm.controls['mansioneQualifica'].value

      let personaObj: IPersona = {
        Nome: nome,
        Cognome: cognome,
        Codice_fiscale: codiceFiscale,
        Data_assunzione: this.formatDateForSave(dataAssunzione),
        Mansione: mansioneQualifica,
        Qualifica: mansioneQualifica
      }

      this.callSavePersona(personaObj)

    }
  }

  /**
   * callback fired when save button is pressed
   */
  onSavePersona() {


  }

  /**
  * callback fired when file is uploaded
  * @param event file
  * @param upload 
  */
  uploadClick(event: any, upload: any) {
    this.uploadedFile = null
    upload.clear()
    if (event.files) {
      this.uploadedFile = event.files[0];
      this.fileName = this.uploadedFile.name
    }
  }

  /**
   * 
   * @param menu 
   * @param event
   */
  openMenu(menu, event) {
    this.optionsAllegato(event)
    menu.toggle(event)
  }

  /**
   * set options allegato
   * @param event 
   */
  private optionsAllegato(event: any) {
    this.translate.get(["LBL_ALLEGATO_APRI", "LBL_ALLEGATO_CANCELLA",]).subscribe(res => {
      this.itemsAllegato = [
        {
          label: res["LBL_ALLEGATO_APRI"], icon: 'pi pi-download', command: () => {
            this.openAllegato(event);
          }
        }
        // ,
        // {
        //   label: res["LBL_ALLEGATO_CANCELLA"], icon: 'pi pi-trash', command: () => {
        //     this.deleteAllegato(event);
        //   }
        // }
      ]
    })
  }

  /**
   * open allegato in other tab
   */
  openAllegato(event: any) {

  }

  /**
   * delete allegato service
   * @param event 
   */
  deleteAllegato(event: any) {

  }

  /**
   * determines whether save button is disabled
   */
  isDisabledButton(): boolean {
    let isDisabled: boolean = true

    if (this.uploadedFile || this.fileName) {
      isDisabled = false
    }

    return isDisabled
  }

  /**
   * create/update persona
   * @param personaObj personaObj
   */
  callSavePersona(personaObj: IPersona) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(personaObj)
    this.personaService.save(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.alertUtil.showAlert("LBL_NEW_PERSONA_SUCCESS", null, null, null, () => {
            this.ref.close(personaObj)
          })
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * format date from to DD/MM/YYYY YYYY-MM-DDTHH:mm:ss
   * @param dateValue item value
   */
  formatDateForSave(dateValue: Date): string {
    let valueMoment = Moment(dateValue, "DD/MM/YYYY", true)
    if (valueMoment.isValid()) {
      return valueMoment.format("YYYY-MM-DDTHH:mm:ss")
    }
    return null
  }
}
